var customContact = class extends HTMLElement {
    select = this.querySelector("selectric-component");
    selectricEl = $(this.select);
    imageUploader = $('.input-images');
    form = this.querySelectorAll("form");
    formButton = this.querySelectorAll("button[type='submit']");
    fileInput = this.querySelectorAll("input[type='file']");
    formUrl = 'https://api.nex-tep.com/api/gorgias';
    currentUrl = window.location.href;
    emailInput = document.querySelector('input[name="contact[email]"]');
    errorSpan = document.getElementById('email-error');

    connectedCallback() {
        this.imageUploader.each(function (index, element) {
            if(this.childElementCount == 0){
                'cioansdoiasnda'
                $(this).imageUploader(); 
            }
        });
        this.selectricEl.on('selectric-change', e => this.selectricChangeHandler(e));
        this.formButton.forEach(button => {
            button.addEventListener("click", e => {
                this.formSubmitHandler(e); 
            });
        });
        this.fileInput.forEach(input => {
            input.addEventListener("change", e => {
                this.fileChangeHandler(e);
            });
        });
        // Deep link: /pages/contact?<order number> preselects the return form.
        // Ignore regular query strings (utm_*, etc.) so they are not treated as an order number.
        const query = this.currentUrl.split('?')[1];
        if (query && !query.includes('=') && !query.includes('&')) {
            this.openForm();
        }
    }
    fileChangeHandler(e) {
        let filename = e.target.files[0].name;
        e.target.nextElementSibling.textContent = filename;
    }

    selectricChangeHandler(e) {
        let el = $(e.currentTarget);
        let select = el.find('select');
        let value = select.val();
        let formData = $('div[data-form="' + value + '"]');

        formData.addClass('visible');
        formData.siblings().removeClass('visible');
        const reasonInput = formData.find('input[name="reason"]');

        // if (reasonInput.length > 0) {
        //     reasonInput[0].setAttribute('value', el.find(".label").text());
        // }
    }
    formSubmitHandler(e) {
        e.preventDefault();
        const el = e.currentTarget;
        const form = e.target.closest('form');
        form.setAttribute('encType', 'multipart/form-data');

        if (!this.validateForm(form)) {
            return;
        }
        const formData = new FormData(form);

        fetch(this.formUrl, {
            method: form.method,
            body: formData
        })
            .then(response => {
                if (response.ok) {
                    this.displayMessage('Success! The form was submitted successfully.', 'success', el);
                    form.reset();
                } else {
                    throw new Error('An error occurred while submitting the form.');
                }
            })
            .catch(error => {
                this.displayMessage('Error: ' + error.message, 'error', el);
            });
    }

    validateForm(form) {
        const inputs = form.querySelectorAll('input[required]');
        const textareas = form.querySelectorAll('textarea[required]');

        let isValid = true;

        inputs.forEach(input => {
            if (!input.value.trim()) {
                isValid = false;
                input.classList.add('field--error');
            } else {
                input.classList.remove('custom-contact__input--error');
            }
        });

        textareas.forEach(textarea => {
            if (!textarea.value.trim()) {
                isValid = false;
                textarea.classList.add('field--error');
            } else {
                textarea.classList.remove('custom-contact__textarea--error');
            }
        });

        return isValid;
    }

    displayMessage(message, type, el) {
        const messageElement = document.createElement('div');
        messageElement.classList.add('custom-contact__message');

        if (type === 'success') {
            messageElement.classList.add('custom-contact__message--success');
        } else if (type === 'error') {
            messageElement.classList.add('custom-contact__message--error');
        }

        messageElement.textContent = message;

        const mainElement = document.querySelector('.custom-contact__main');
        const contactFormWrapper = document.querySelector('.custom-contact__form-container');

        mainElement.insertBefore(messageElement, contactFormWrapper.nextSibling);

        const buttonLoader = document.querySelector('.loader-button__loader');
        // Add timeout to remove messageElement after 5 seconds
        setTimeout(function () {
            messageElement.remove();
            // Use setAttribute method instead of add
            el.setAttribute('aria-busy', false);
        }, 5000);
    }

    openForm() {
        const returnFormData = 3;
        let orderNumber = this.currentUrl.split('?')[1];
        let select = this.querySelector('select');

        select.value = returnFormData;

        // prefill form fields
        const targetForm = this.querySelector('div[data-form="' + returnFormData + '"]');
        const orderNumField = targetForm && targetForm.querySelector('input[name="contact[order_number]"]');
        if (orderNumField) {
            orderNumField.value = orderNumber;
            orderNumField.classList.add('is-filled');
        }

        // set current label
        const label = this.querySelector('span.label');
        label.textContent = this.querySelector('li[data-index="' + returnFormData + '"]').textContent;

        const entries = this.querySelectorAll('li');
        entries.forEach(entry => {
            entry.classList.remove('selected');
        });
        const entry = this.querySelector('li[data-index="' + returnFormData + '"]');
        entry.classList.add("selected");

        $(select).trigger('selectric-change');
    }
};

window.customElements.define("custom-contact", customContact);
